import { render } from "./WarningArticleList.vue?vue&type=template&id=e09148ca&scoped=true"
import script from "./WarningArticleList.vue?vue&type=script&lang=js"
export * from "./WarningArticleList.vue?vue&type=script&lang=js"

import "./WarningArticleList.vue?vue&type=style&index=0&id=e09148ca&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e09148ca"]])

export default __exports__